/**
 * Tile de estadística. Contrato: etiqueta en minúscula sin dos puntos, valor
 * compacto, variación opcional contra una base con NOMBRE, nota opcional. Sin
 * gráfica: aquí la respuesta correcta es el número, no un dibujo — son cifras
 * contables exactas, no una tendencia.
 *
 * La variación va en tinta secundaria, no en verde o rojo. En un balance no
 * existe una dirección «buena»: más pasivo no es peor ni más activo es mejor,
 * depende de por qué. Colorearla afirmaría un juicio que el dato no sostiene.
 */

interface Props {
  label: string;
  value: string;
  /** Variación firmada; se acompaña SIEMPRE del período base en `deltaBase`. */
  delta?: string;
  deltaBase?: string;
  note?: string;
  hero?: boolean;
  /** Filete navy: distingue la fila financiera de la operativa sin encabezado. */
  mass?: boolean;
  children?: React.ReactNode;
}

export function StatTile({ label, value, delta, deltaBase, note, hero, mass, children }: Props) {
  const classes = ["tile", hero && "hero", mass && "mass"].filter(Boolean).join(" ");
  return (
    <div className={classes}>
      <div className="tile-label">{label}</div>
      <div className="tile-value">{value}</div>
      {delta && (
        <div className="tile-delta">
          {delta}
          {deltaBase && <span className="tile-delta-base"> vs. {deltaBase}</span>}
        </div>
      )}
      {note && <div className="tile-note">{note}</div>}
      {children}
    </div>
  );
}
